import { Injectable } from '@angular/core';

import { SessionService } from '../session/session.service';
import { TeamCompanyUsersService } from '../teamcompanyusers/teamcompanyusers.service';
import { UsersService } from '../users/users.service';
import { PayrollProviderConnectionResponse, PayrollService } from '../payroll/payroll.service';

@Injectable({
  providedIn: 'root',
})
export class PayrollAdminLandingService {
  readonly teamsRoute = '/payrolladmin/teams';
  readonly companyRoute = '/payrolladmin/company/company';

  constructor(
    private sessionService: SessionService,
    private teamCompanyUsersService: TeamCompanyUsersService,
    private usersService: UsersService,
    private payrollService: PayrollService,
  ) {}

  async getLandingRoute(): Promise<string> {
    const companies = await this.getPayrollCompanies();
    const hasPayrollConnection = await this.hasPayrollConnection(companies);

    return hasPayrollConnection ? this.teamsRoute : this.companyRoute;
  }

  private async hasPayrollConnection(companies: any[]): Promise<boolean> {
    if (!Array.isArray(companies) || companies.length === 0) {
      return false;
    }

    const providerConnections = await Promise.all(
      companies.map((company) => company?.id
        ? this.payrollService.getCompanyPayrollProviderConnection(company.id).catch(() => null)
        : Promise.resolve(null))
    );
    return providerConnections.some((connection) => this.hasProviderConnection(connection));
  }

  private hasProviderConnection(connection: PayrollProviderConnectionResponse | null | undefined): boolean {
    return this.payrollService.hasActivePayrollProviderConnection(connection);
  }

  private async getPayrollCompanies(): Promise<any[]> {
    const userId = this.sessionService.getUserId();
    if (!userId) {
      return [];
    }

    try {
      const companies = await this.teamCompanyUsersService.getCompaniesForUser(userId);
      const response = companies?.plain?.() || companies;
      return Array.isArray(response) ? response : [];
    } catch (_) {
      return this.usersService.getTeamCompanies();
    }
  }
}
